<template>
    <div>
        <div class="link">
            友情链接：&nbsp;
            <a href="https://edu.sc.gov.cn/" target="_blank">四川省教育厅</a>&nbsp;&nbsp;&nbsp;
            <a href="https://www.sceea.cn/" target="_blank">四川省教育考试院</a>&nbsp;&nbsp;&nbsp;
            <a href="https://www.sceeic.cn/#/" target="_blank">四川省招生考试指导中心</a>&nbsp;&nbsp;&nbsp;
            <a href="https://gkt.sceeic.cn/#/" target="_blank">高考通</a>&nbsp;&nbsp;&nbsp;
            <a href="https://www.sceeo.com/" target="_blank">四川招考服务平台</a>
        </div>
        
        <div class="msg">
            <hr style="border: 1px solid #8d8787;">
            <div class="contact">
            <h3>联系我们</h3>
            <hr>
            <p><span>工作时间</span>&nbsp;&nbsp;&nbsp;&nbsp;工作日9:00-17:00</p>
            <p><span>客 服 QQ</span>&nbsp;&nbsp;&nbsp;&nbsp;371956228</p>
            <p><span>咨询电话</span>&nbsp;&nbsp;&nbsp;&nbsp;028-62505623</p>
        </div>
            <div class="about">
                <a href="/about"><h3>关于我们</h3></a>
                <hr>
                <p><span>主办单位</span>&nbsp;&nbsp;&nbsp;&nbsp;四川省招生考试指导中心</p>
                <p><span>承办单位</span>&nbsp;&nbsp;&nbsp;&nbsp;四川锦兴国试书业有限公司</p>
                <p><span>技术支持</span>&nbsp;&nbsp;&nbsp;&nbsp;四川锦兴教育咨询有限公司</p>
            </div>
            <div class="address">
                <h3>书店地址</h3>
                <hr>
                <p>成都市高新区芳沁街81号四川省招生考试书店</p>
            </div>
            <div class="promise">
                <span>商家承诺：</span>
                <p>48小时内通过顺丰发货（节假日除外）图书如无质量问题概不退换 谢谢理解！</p>
            </div>
        </div>
        
    </div>
</template>

<script>
export default {
    name: "Footer"
}
</script>

<style scoped>
hr:nth-child(2) {
    width: 40%;
    margin-top: -5px;
    background: linear-gradient(to right, #49aef1, #555557);
    border: none ;
    height: 5px;
    margin-bottom: 30px;
}
.link{
    margin-left: 250px;
    margin-top: 20px;
    display:block;
    float: left;
    clear: both;
    color: #e0dcdc;
}
.msg{
    margin-left: 250px;
    margin-top: 20px;
    display: block;
    float: left;
    clear: both;
    text-align: left;
    overflow: hidden;
    box-sizing: border-box;
}
.contact , .about , .address , .promise{
    float: left;
    width: 280px;
    height: 200px;
    margin-top: 20px;
    overflow: hidden;
    box-sizing: border-box;
}
.about {
    margin-left: 30px;
}
p{
    margin-top: 10px;
    color: #e0dcdc;
}
span{
    color: #a2a5a7;
}
h3{
    color: #d4d4d4;
}
.address{
    width: 180px;
    margin-left: 80px;
}
.address hr{
    width: 60%;
}
.promise{
    background-color: #4e5357;
    height: 150px;
    width: 390px;
    margin-left: 150px;
    display: block;
}
.promise span, .promise p{
    padding-left: 50px;
    padding-right: 20px;
    padding-top: 10px;
}
.promise{
    padding-top: 30px;
}
a{
    color: #e0dcdc;
    text-decoration: none;
}
a:hover{
    color: #49aef1;
}
</style>
